import { render, staticRenderFns } from "./ClientConsultation.vue?vue&type=template&id=e9fbbec0&scoped=true"
import script from "./ClientConsultation.vue?vue&type=script&lang=ts"
export * from "./ClientConsultation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9fbbec0",
  null
  
)

export default component.exports